<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-btn @click="exportData" color="primary" dark class="mb-4 ml-3">Eksportuj</v-btn>
		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr :class="props.item.projectCreationTermExpired ? 'termExpired' : ''" :key="props.item.id">
					<td style="width: 70px;">
						<v-tooltip bottom v-if="!props.item.agencyAccreditedForContest && roles.isAgencyEmployee()">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>Placówka nie jest akredytowana na żaden kraj z tego naboru</span>
						</v-tooltip>
						<v-tooltip bottom v-else-if="props.item.projectCreationTermExpired">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>Upłynął termin składania wniosków</span>
							<span v-if="props.item.agencyContestStatus === 'FINISHED'">; Nabór zakończony</span>
						</v-tooltip>
					</td>
					<td>{{ props.item.name }}</td>
					<td>{{ props.item.endDate }}</td>
					<td>{{ props.item.departmentName }}</td>
					<td>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									v-if="isAdminOrSecretary(props.item)"
									@click="showContestPanel(props.item)">
									<v-icon v-on="on">
										build
									</v-icon>
								</v-btn>
							</template>
							<span>Panel naboru</span>
						</v-tooltip>
						<v-tooltip v-if="props.item.agencyAccreditedForContest || roles.isAdministrator() || roles.isLocalAdministrator()" bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon v-if="roles.isAgencyEmployee() || roles.isAdministrator() || roles.isLocalAdministrator()"
									@click="previewApplicationForm(props.item)">
									<v-icon v-on="on">
										search
									</v-icon>
								</v-btn>
							</template>
							<span>Podgląd formularza wniosku</span>
						</v-tooltip>
						<v-tooltip v-if="props.item.agencyAccreditedForContest" bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon v-if="roles.isAgencyEmployee()"
									@click="placeAnProject(props.item)">
									<v-icon v-on="on" :class="getSendIconColor(props.item)">
										mail
									</v-icon>
								</v-btn>
							</template>
							<span>{{getSendIconHint(props.item)}}</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									v-if="showBrowseOfferButton(props.item)"
									@click="browseOffers(props.item)">
									<v-icon v-on="on">
										mail
									</v-icon>
								</v-btn>
							</template>
							<span>Ocena wniosków</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									v-if="showEvaluationSummaryButton(props.item)"
									@click="evaluationSummary(props.item)">
									<v-icon v-on="on">
										event_seat
									</v-icon>
								</v-btn>
							</template>
							<span>Zbiorcza ocena</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon small
									v-if="showBrowseProjectsButton(props.item)"
									@click="browseProjects(props.item)">
									<v-icon small v-on="on">
										business
									</v-icon>
								</v-btn>
							</template>
							<span>Projekty</span>
						</v-tooltip>
						<v-tooltip v-if="props.item.agencyAccreditedForContest" bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon v-if="roles.isAgencyEmployee()"
									@click="viewFiles(props.item)">
									<v-icon v-on="on">
										folder
									</v-icon>
								</v-btn>
							</template>
							<span>Dokumenty naboru</span>
						</v-tooltip>
					
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									v-if="isAdminOrSecretary(props.item) && props.item.agencyContestStatus === 'NOT_STARTED'"
									@click="deleteContest(props.item)">
									<v-icon v-on="on" color="lightred">
										delete
									</v-icon>
								</v-btn>
							</template>
							<span>Usuń nabór</span>
						</v-tooltip>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {AgencyContest} from "@/api/generated/AgencyContest";

	export default {
		name: "AgencyContestDataTable",
		props: {
			value: Object,
		},

		watch: {

			"dataTable.pagination": {
				handler () {
					this.getItemList();
				},
				deep: true
			}
		},

		methods: {
			exportData () {
				let endpointMainPath = "agency-contest";
				let sort = this.buildSort();
				let path = "/" + endpointMainPath + "/export?search=" + this.dataTable.search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList () {
				this.dataTable.search = "";
				let sort = this.buildSort();
				Api.get(this, "/agency-contest/list?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page
					+ "&result=" + this.dataTable.pagination.rowsPerPage
					+ "&sort=".concat(sort), response => {
					this.dataTable.itemList = response.itemList;
					this.dataTable.itemCount = response.itemCount;
				});
			},

			isAdminOrSecretary (item) {
				return this.roles.isAdministrator() ||
					this.roles.isLocalAdministrator() ||
					((this.roles.isDepartmentEmployee() || this.roles.isExpert()) && item.secretary);
			},

			isAdminOrSecretaryOrLeader (item) {
				return this.roles.isAdministrator() ||
					this.roles.isLocalAdministrator() ||
					((this.roles.isDepartmentEmployee() || this.roles.isExpert()) && (item.secretary || item.leader));
			},

      showManageCommitteesButton(item) {
        return this.evaluationAndAssignmentDataAccessible(item) && this.isAdminOrSecretary(item);
      },

      showBrowseProjectsButton(item) {
        return ['ANNOUNCED', 'FINISHED'].includes(item.agencyContestAnnouncementStatus)
            && (this.isAdminOrSecretary(item) || this.isFinishedAndDepartmentWorker(item));
      },

      showEvaluationSummaryButton(item) {
        return this.evaluationAndAssignmentDataAccessible(item)
            && (this.isAdminOrSecretary(item) || this.isFinishedAndDepartmentWorker(item));
      },

      showBrowseOfferButton(item) {
        return this.isAdminOrSecretaryOrLeader(item) || this.isFinishedAndDepartmentWorker(item);
      },

      isFinishedAndDepartmentWorker(item) {
        return item.contestFromUserDepartment && item.agencyContestStatus === 'FINISHED' && this.roles.isDepartmentEmployee();
      },

      buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			deleteContest (contest) {
				this.$confirm("Czy na pewno chcesz usunąć nabór?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie naboru",
					width: 500
				})
					.then(result => {
						if (result) {
							AgencyContest.delete(this, contest.id, successResponse => {
								this.$messagesBus.$emit("success", "Nabór został pomyślnie usunięty", successResponse);
								this.getItemList();
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się usunąć naboru", errorResponse);
							});
						}
					});
			},

			evaluationAndAssignmentDataAccessible (item) {
				return (item.evaluationOpen || item.evaluationFinished);
			},

			browseOffers (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/project-list");
			},

			browseProjects (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/projects");
			},

			evaluationSummary (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/evaluation-summary-teams");
			},

			viewFiles (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/view-files");
			},

			showContestPanel (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/panel/main-data");
			},

			placeAnProject (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/my-project-list");
			},

			previewApplicationForm (contest) {
				this.$router.openInNewTab("/agency-contest/" + contest.id + "/empty-application");
			},

			manageCommittees (contest) {
				this.$router.push("/app/agency-contest/" + contest.id + "/manage-teams");
			},

			getSendIconColor (agencyContest) {
				if (agencyContest.projectCreationTermExpired === true) {
					return 'yellow-icon';
				}
				return 'green-icon';
			},

			getSendIconHint (agencyContest) {
				if (agencyContest.projectCreationTermExpired === true) {
					return 'Lista wniosków';
				}
				return 'Złóż wniosek';
			},
		},

		data () {
			return {
				dataTable: this.value,
			};
		}
	};
</script>

<style scoped>
	.termExpired {
		background-color: rgb(232, 232, 232);
	}

	.theme--dark .termExpired {
		background-color: #606060 !important;
	}

	.yellow-icon {
		color: #cccc00 !important;
	}

	.green-icon {
		color: green !important;
	}
</style>
